import $ from 'jquery';

const PasteImageMixin = {
  data() {
    return {
      keyListener: null,
      max: {
        height: 1536.0,
        width: 1536.0,
      },
      clipboardHasImage: false,
    };
  },
  methods: {
    retrieveImageFromClipboardAsBase64(imageblobs, callback, imageFormat) {
      for (let i = 0; i < imageblobs.length; i += 1) {
        const blob = imageblobs[i];
        this.resizeBlob(blob, callback, imageFormat);
      }
    },
    resizeBlob(blob, callback, imageFormat) {
      const mycanvas = document.createElement('canvas');
      const ctx = mycanvas.getContext('2d');

      // Create an image
      const img = new Image();

      const self = this;

      // Once the image loads, render the img on the canvas
      img.onload = function onload() {
        // Update dimensions of the canvas with the dimensions of the image
        const [width, height] = self.getConstraints(this.width, this.height);

        mycanvas.width = width;
        mycanvas.height = height;

        // Draw the image
        ctx.drawImage(img, 0, 0, width, height);
        // ctx.drawImage(img, width / 2, height / 2, width, height);

        // Execute callback with the base64 URI of the image
        if (typeof callback === 'function') {
          callback(mycanvas.toDataURL(imageFormat || 'image/png'));
        }
      };

      // Crossbrowser support for URL
      const URLObj = window.URL || window.webkitURL;

      // Creates a DOMString containing a URL representing the object given in the parameter
      // namely the original Blob
      img.src = URLObj.createObjectURL(blob);
    },
    getConstraints(width, height) {
      let scale = 1;
      if (width >= height && width > this.max.width) {
        scale = this.max.width / width;
      } else if (height > width && height > this.max.height) {
        scale = this.max.height / height;
      }
      console.log('RESIZE', [width * scale, height * scale]);
      return [width * scale, height * scale];
    },
    activatePaste() {
      if (!this.keyListener) {
        this.keyListener = (event) => {
          const items = [];
          const dtitems = event.originalEvent.clipboardData
            && event.originalEvent.clipboardData.items
            ? event.originalEvent.clipboardData.items
            : [];
          for (let i = 0; i < dtitems.length; i += 1) {
            const item = dtitems[i];
            if (item.type.includes('image')) items.push(item.getAsFile());
          }
          this.retrieveImageFromClipboardAsBase64(items, (base64) => {
            if (base64 && this.pasteImage) this.pasteImage(base64);
          });
        };
      }
      // $(window).bind('paste', this.keyListener);
    },
    deactivatePaste() {
      console.log('Deactivate Paste');
      $(window).unbind('paste', this.keyListener);
    },
    async triggerPaste() {
      const data = await navigator.clipboard.read();
      const promises = [];
      data.map((item) => item.types
        .filter((type) => type.includes('image'))
        .map((type) => promises.push(item.getType(type))));

      const blobs = await Promise.all(promises);
      this.retrieveImageFromClipboardAsBase64(blobs, (base64) => {
        if (base64 && this.pasteImage) this.pasteImage(base64);
      });
    },
    checkClipboardHasImage() {
      this.clipboardHasImage = false;

      if (this.isIPad) {
        const clipboard = localStorage.getItem('clipboard');
        this.clipboardHasImage = !!clipboard;
        return;
      }

      if (!navigator.clipboard || !navigator.clipboard.read) {
        return;
      }
      // navigator.clipboard.read().then((clipboardContent) => {
      //   this.clipboardHasImage = clipboardContent.filter((item) => item.types.filter((type) => type.includes('image')).length > 0).length > 0;
      // });
      this.clipboardHasImage = true;
    },
  },
};
export default PasteImageMixin;
